import * as _ from 'underscore';
import { Module } from '../Module';
import { Groups } from '../resources/Groups';
import { IResult } from '../ServerApi/types/IResponse';
import { ConfirmActionDialog, IConfirmActionDialogInstance } from './ConfirmActionDialog';
import { CreateGroupActionNotification } from './GroupsActionNotification';
import { ServerService } from './ServerService';

export interface ICreateGroupDialogScope extends ng.IScope {
  description: string;
  input: {
    text: string;
    maxLength?: number;
  };
}

export class CreateGroupDialogAction {

  public static $inject = ['$translate',
                           'ConfirmActionDialog',
                           'CreateGroupActionNotification',
                           'Groups',
                           'ServerService'];

  constructor(
    private $translate: ng.translate.ITranslateService,
    private ConfirmActionDialog: ConfirmActionDialog,
    private createGroupActionNotification: CreateGroupActionNotification,
    private Groups: Groups,
    private ServerService: ServerService) { }

  public showCreateGroupDialog(parentScope: ng.IScope): ng.IPromise<IResult> {

    const dialogScope = <ICreateGroupDialogScope> parentScope.$new();

    dialogScope.description = this.$translate.instant('createGroupDesc');
    dialogScope.input = {
      text: '',
      maxLength: 255
    };

    const activeDirectoryEnabled = this.ServerService.isServerDomainFamilyActiveDirectory();

    const dialogInstance = this.ConfirmActionDialog.open({
      title: this.$translate.instant(activeDirectoryEnabled ? 'createLocalGroupTitle' : 'createGroupTitle'),
      bodyTemplateUrl: 'confirmActionDialogInput.html',
      scope: dialogScope,
      position: { reserveHeight: 250 },
      confirmDisabled: () => _.isEmpty(dialogScope.input.text),
      actionName: this.$translate.instant('createGroupDialogSubmit'),
      action: (dialogInstance: IConfirmActionDialogInstance) => {
        return this.Groups.createGroup(dialogScope.input.text).then((result: IResult) => {
          this.createGroupActionNotification.notify(
            (errorMsg: string) => {
              dialogInstance.showErrorMessage(errorMsg);
            },
            result,
            dialogScope.input.text);
        });
      }
    });
    dialogInstance.result.finally(() => dialogScope.$destroy());
    return dialogInstance.result;
  }

}

Module.instance().service('CreateGroupDialogAction', CreateGroupDialogAction);
